var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.736 23.0001C12.411 23.0001 12.9582 22.4529 12.9582 21.7779C12.9582 21.1029 12.411 20.5557 11.736 20.5557C11.0609 20.5557 10.5137 21.1029 10.5137 21.7779C10.5137 22.4529 11.0609 23.0001 11.736 23.0001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2915 23.0001C20.9665 23.0001 21.5137 22.4529 21.5137 21.7779C21.5137 21.1029 20.9665 20.5557 20.2915 20.5557C19.6165 20.5557 19.0693 21.1029 19.0693 21.7779C19.0693 22.4529 19.6165 23.0001 20.2915 23.0001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95819 1H5.74009L8.57651 17.0731H23.7041",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0693 13.1837L23.3165 13.2907C23.4258 13.2908 23.5318 13.2529 23.6164 13.1837C23.701 13.1144 23.7589 13.0179 23.7804 12.9107L25.4822 4.40145C25.4959 4.33283 25.4943 4.26203 25.4773 4.19414C25.4604 4.12625 25.4285 4.06297 25.3842 4.00886C25.3398 3.95476 25.284 3.91118 25.2207 3.88128C25.1574 3.85138 25.0883 3.83589 25.0183 3.83594L6.52547 3.83594",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.fcbf6db93782def072af9d871f230cc9.svg";
export { ForwardRef as ReactComponent };